import { useEffect, useState } from "react";
import { Minus, Plus } from "lucide-react";

export default function CollapsibleSection({ id, title, icon, badge, actions, defaultOpen = true, children, testid }) {
  const key = `event-section:${id}`;
  const [open, setOpen] = useState(() => {
    try {
      const v = sessionStorage.getItem(key);
      return v === null ? defaultOpen : v === "1";
    } catch { return defaultOpen; }
  });
  useEffect(() => { try { sessionStorage.setItem(key, open ? "1" : "0"); } catch {} }, [open, key]);
  return (
    <div className="rounded-lg border bg-card" data-testid={testid || `section-${id}`}>
      <div className="flex flex-wrap items-center gap-2 border-b px-5 py-3">
        <button type="button" data-testid={`section-toggle-${id}`} onClick={() => setOpen(!open)}
          className="flex min-w-0 flex-1 items-center gap-2 text-left">
          {icon}
          <h2 className="font-heading text-base font-semibold">{title}</h2>
          {badge}
        </button>
        {open && actions}
        <button type="button" data-testid={`section-collapse-btn-${id}`} onClick={() => setOpen(!open)}
          className="flex h-7 w-7 items-center justify-center rounded-md border text-slate-500 hover:bg-slate-50"
          aria-label={open ? "Minimize section" : "Maximize section"}>
          {open ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
        </button>
      </div>
      {open && children}
    </div>
  );
}
